/*eslint-disable no-unused-vars*/

import { createApp } from 'vue'
import Maska from 'maska'
import form from '@/store/form'
import './assets/js/css/ImportCss'
import Cookies from 'js-cookie'
import { Fancybox } from '@fancyapps/ui'
import MenuMobile from '@/assets/js/Menu/MenuMobile/MenuMobile'
import MenuForum from '@/assets/js/Menu/MenuForum/MenuForum'
import SearchButton from '@/assets/js/Search/SearchButton'
import Faq from '@/assets/js/Faq/Faq'
import AjaxCommercial from '@/assets/js/Ajax/AjaxCommercial/AjaxCommercial'
import AjaxFavorite from '@/assets/js/Ajax/AjaxFavorite/AjaxFavorite'
import SwiperSlider from '@/assets/js/Swiper/Swiper'
import VideoImg from '@/assets/js/Video/VideoImg/VideoImg'
import WidgetSocial from '@/assets/js/Widget/WidgetSocial/WidgetSocial'
import Political from '@/assets/js/Political/Political'
import TabNumber from '@/assets/js/Tab/Number/Number'
import AppSearch from '@/components/Search/AppSearch'
import AppFormSubscribe from '@/components/Form/FormSubscribe/AppFormSubscribe'

// Подключаем глобально jQuery
const $ = window.$ = window.jQuery = require('jquery')

// Подключаем глобально Cookie
window.Cookies = Cookies

document.addEventListener('DOMContentLoaded', () => {
    Fancybox.bind('[data-subscribe]')
    new MenuMobile()
    new MenuForum()
    new SearchButton()
    new Faq()
    new AjaxCommercial()
    new AjaxFavorite()
    new SwiperSlider()
    new VideoImg()
    new WidgetSocial()
    new Political()
    new TabNumber()

    if(document.getElementById('block--search') != null) {
        createApp({})
            .component('block-search', AppSearch)
            .mount('#block--search')
    }

    if(document.getElementById('form--subscribe')!= null) {
        createApp({})
            .component('form-subscribe', AppFormSubscribe)
            .use(form)
            .use(Maska)
            .mount('#form--subscribe')
    }
})
